/**
 * Mobile accordion behaviour for the pre-rendered primary navigation.
 *
 * Source of truth is `aria-expanded` on the toggle button. A `data-open`
 * attribute on the parent <li> mirrors it so CSS can use cheap attribute
 * selectors instead of :has() — avoids re-evaluating :has() across the
 * 500 KB nav tree on every tap.
 *
 * Desktop interaction is driven separately by hover-controls.js + :hover CSS,
 * so the two never touch each other's state.
 */
(function () {
    const nav = document.getElementById('main-nav');
    if (!nav) {
        return;
    }

    nav.addEventListener('click', function (event) {
        const button = event.target.closest('[data-nav-toggle]');
        if (!button || !nav.contains(button)) {
            return;
        }

        const li = button.closest('li');
        if (!li) {
            return;
        }

        const willExpand = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(willExpand));

        if (willExpand) {
            li.setAttribute('data-open', '');
        } else {
            li.removeAttribute('data-open');
        }
    });
}());
